import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './sbg-dynamic-share-price-historical.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import * as $ from 'jquery';
import axios from 'axios';
var SbgDynamicSharePriceHistorical = /** @class */ (function (_super) {
    tslib_1.__extends(SbgDynamicSharePriceHistorical, _super);
    function SbgDynamicSharePriceHistorical(element) {
        return _super.call(this, element) || this;
    }
    SbgDynamicSharePriceHistorical.prototype.init = function () {
        this.containerLatestPrice = this.element.querySelector('.js-share-price-latest-price');
        this.containerDateContainer = this.element.querySelector('.js-share-price-date-container');
        this.containerDate = this.element.querySelector('.js-share-price-date');
        this.containerDatePrice = this.element.querySelector('.js-share-price-date-price');
        this.inputPaymentDate = this.element.querySelector('select[name=payment_date]');
        this.inputNumberShares = this.element.querySelector('input[name=number_shares]');
        this.buttonCalculate = this.element.querySelector('.js-calculator-calculate');
        this.buttonReset = this.element.querySelector('.js-calculator-reset');
        this.valueHistoricalJson = {};
        this.apiFeedLatest();
        this.apiFeedHistorical();
        TooltipsService.initTooltips();
        $(document).ready(function () {
            // start dateppicker
            $('input.js-start-date').datepicker({
                format: "dd/mm/yyyy",
                todayHighlight: true,
                enableOnReadonly: true,
                autoclose: true,
                daysOfWeekDisabled: [0, 6]
            });
        });
    };
    SbgDynamicSharePriceHistorical.prototype.bindEvents = function () {
        var _this = this;
        if (this.buttonCalculate) {
            this.buttonCalculate.addEventListener('click', function (event) {
                _this.calculate();
            });
        }
        if (this.buttonReset) {
            this.buttonReset.addEventListener('click', function (event) {
                _this.containerDateContainer.classList.add('d-none');
            });
        }
    };
    SbgDynamicSharePriceHistorical.prototype.apiFeedLatest = function () {
        var _this = this;
        var url = "https://df.marketdata.feeds.iress.com/feed/2277/?token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzZWNJRCI6NTMyLCJpYXQiOjE2ODUzNDg0MDMsImF1ZCI6ImlyZXNzLmNvLnphIiwiaXNzIjoiYWNjb3VudHMuaXJlc3MuY28uemEifQ._tcXkzJv1YmKZsaRCUMO0GpDsSYywo_QDuim7CKLQLqrGQSS8cFJZS2JeGfxt0B2yBnPkx6I4ou3KCwrSwEL2w";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            var json = response.data;
            if (json.Snapshot.length > 0) {
                _this.containerLatestPrice.innerHTML = _this.roundFormatterV2(parseFloat(json.Snapshot[0].trade), 0, true);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    SbgDynamicSharePriceHistorical.prototype.apiFeedHistorical = function () {
        var _this = this;
        var url = "https://df.marketdata.feeds.iress.com/feed/2279/?token=eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJzZWNJRCI6NTMyLCJpYXQiOjE2ODU2OTQ5MDAsImF1ZCI6ImlyZXNzLmNvLnphIiwiaXNzIjoiYWNjb3VudHMuaXJlc3MuY28uemEifQ.lO2e-kFA9kwSjqfUaRlvOlcjBHp8MbJtir0_Jlfoi_ySqclj-mOJ1vRQLjwhENImnMAGCU_If-k4rhyysgA_kw&dateranges=&codes=SBK";
        var valueLastDate = this.valueLastDate;
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        axios.get(url).then(function (response) {
            var json = response.data;
            if (json.Snapshot.length > 0) {
                // set json
                _this.valueHistoricalJson = json.Snapshot;
                // Set Todays Date
                var dateNew = new Date();
                var dateYear = dateNew.getFullYear();
                var dateMonth = (dateNew.getMonth() + 1).toString().padStart(2, "0");
                var dateDay = dateNew.getDate().toString().padStart(2, "0");
                var dateFormatted = dateDay + '/' + dateMonth + '/' + dateYear;
                // $('input.js-start-date').datepicker('setDate', dateFormatted);
                // Set the First Date
                var firstDate = json.Snapshot[0].TimeSeriesDate;
                var dateSplittedFirst = firstDate.split('/');
                $('input.js-start-date').datepicker('setStartDate', dateSplittedFirst[2] + '/' + dateSplittedFirst[1] + '/' + dateSplittedFirst[0]);
                // Set Last Date
                var lastDate = json.Snapshot[json.Snapshot.length - 1].TimeSeriesDate;
                var dateSplittedLast = lastDate.split('/');
                valueLastDate = dateSplittedLast[2] + '/' + dateSplittedLast[1] + '/' + dateSplittedLast[0];
                $('input.js-start-date').attr('value', dateSplittedLast[2] + '/' + dateSplittedLast[1] + '/' + dateSplittedLast[0]);
                $('input.js-start-date').datepicker('setEndDate', dateSplittedLast[2] + '/' + dateSplittedLast[1] + '/' + dateSplittedLast[0]);
                $('input.js-start-date').datepicker('setDate', dateSplittedLast[2] + '/' + dateSplittedLast[1] + '/' + dateSplittedLast[0]);
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    SbgDynamicSharePriceHistorical.prototype.calculate = function () {
        var inputDate = this.element.querySelector('input.js-start-date');
        var inputDateValue = inputDate.value;
        var dateSplit = inputDateValue.split('/');
        var dateFormat = dateSplit[2] + '/' + dateSplit[1] + '/' + dateSplit[0];
        var getPrice = 0;
        this.valueHistoricalJson.forEach(function (item) {
            if (item.TimeSeriesDate === dateFormat) {
                getPrice = item.PDCloseInCents;
            }
        });
        var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        this.containerDate.innerHTML = 'Closing price on ' + dateSplit[0] + ' ' + monthNames[parseFloat(dateSplit[1]) - 1] + ' ' + dateSplit[2];
        this.containerDatePrice.innerHTML = this.roundFormatterV2(parseFloat(getPrice), 0, true);
        this.containerDateContainer.classList.remove('d-none');
    };
    SbgDynamicSharePriceHistorical.prototype.roundFormatterV2 = function (expr, decplaces, formatted) {
        if (formatted === void 0) { formatted = false; }
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        var valueFull = str.substring(0, decpoint);
        var valueDecimal = str.substring(decpoint, str.length);
        if (formatted) {
            var lastTwo = valueFull.slice(-2);
            var orginalString = valueFull.substring(0, (valueFull.length - 2));
            valueFull = orginalString + '.' + lastTwo;
        }
        return valueFull;
    };
    return SbgDynamicSharePriceHistorical;
}(Base));
export { SbgDynamicSharePriceHistorical };



//////////////////
// WEBPACK FOOTER
// ./components/sbg-dynamic-share-price-historical/sbg-dynamic-share-price-historical.component.ts
// module id = 722
// module chunks = 0